<template>
  <input-base
      ref="base"
      :read-only="readOnly"
      :validated-field="formField"
      :field-config="fieldConfig"
      :editor-mode="editorMode"
      :grid-editor="gridEditor"
      :open-from-grid="openFromGrid"
  >
    <template slot="readOnly">
      <div v-html="formattedValue"></div>
    </template>
    <template slot="editor">
      <b-form-select
          @change="focusOut"
          @focusout="focusOut"
          v-model="formField.value"
          ref="input"
          :options="options"></b-form-select>
    </template>
    <template slot="label-links">
      <slot name="label-links"></slot>
    </template>
  </input-base>
</template>


<script>
import ValidatedField from "@/validation/ValidatedField";

import InputBase from "@/components/inputs/InputBase";
import {MAX_INT, MIN_INT} from "@/utils/Limits";
import BigDecimal from "@/server/BigDecimal";
import FormValidatedField from "@/components/forms/FormValidatedField";
import FormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig";
import {isPromise} from "@/utils/Objects";
import FormsLoader from "@/components/forms/FormsLoader";

export default {
  name: "ReachSelect",
  components: {InputBase},
  async mounted() {
    this.valChange(this.formField?.value);


    if (this.initialFocus) {
      let canInitialFocus = true;
      if (this.formField?.validatedForm?.formConfig?.onlyEmbedded) {
        canInitialFocus = false;
      }
      if (canInitialFocus) {
        setTimeout(() => this.afterMounted(), 200);
      }
    }
    this.formatVal();
  },

  methods: {
    forceSetValidate(isValid) {
      this.$refs.base.forceSetValidate(isValid);
    },

    async formatVal() {
      let val = this.formField.value;
      if (val) {
        //console.log(`${this.formField.formFieldConfig?.fieldName} -> ${val}`);
      }
      if (!this.format) {
        if (this.formField instanceof FormValidatedField) {
          /** @type {FormValidatedField} */
          const entityField = this.formField;
          if (entityField.isForeignKey()) {
            if (entityField.foreignValueLabel) {
              this.formattedValue = entityField.foreignValueLabel;
              //console.log(`FVx:${this.formattedValue}`);
            } else {
              this.formattedValue = "...";
              let currentId = this.formField.value;
              entityField.getForeignLabel(true).then(label => {
                if (this.formField.value === currentId) {
                  this.formattedValue = label;
                }
              })
            }
          }
        }
        if (this.formattedValue === null || this.formattedValue === undefined) {
          this.formattedValue = this.formField.value !== null ? this.formField.value + '' : "";
        }
        //console.log(`FVy:${this.formattedValue}`);
      } else {
        let val = this.format(this.formField.value, this.formField);
        if (isPromise(val)
        ) {
          val.then(v => {
            this.formattedValue = v;
          });
        } else {
          this.formattedValue = val;
        }
//console.log(`FVz:${this.formattedValue}`);
      }
    },

    afterMounted() {
      if (!this.readOnly) {
        if (this.$refs.input) {
          this.$refs.input.focus();
        }
      }
    },
    focusIn() {
    },
    focusOut() {
      this.formField?.validate();

    },
    valChange(val) {
      this.formatVal();
      this.$emit("change-parent");
    },
    optChange(val) {
      if (this.readOnly) {
        this.formatVal();
      }
    }
  },


  props: {
    readOnly: {
      type: Boolean,
      default:
          false
    },
    editorMode: {
      type: Boolean,
      default:
          false
    },
    helpTitle: {
      type: String,
      default:
          ""
    },
    helpMessage: {
      type: String,
      default:
          ""
    },
    formField: {
      type: ValidatedField,
      default:
          null
    },
    fieldConfig: {
      type: FormFieldConfig,
      default:
          null
    },
    label: {
      type: String,
      default:
          ""
    },
    hint: {
      type: String,
      default:
          ""
    },
    allowNull: {
      type: Boolean,
      default:
          true
    },
    initialFocus: {
      type: Boolean,
      default:
          false
    },
    options: {
      type: Array,
      default:
          () => []
    },
    openFromGrid: {default: false},
    gridEditor: {default: null}
  },

  watch: {
    'formField':
        function (val) {
          this.valChange(val.value);
        },
    'formField.value':
        function (val) {
          this.valChange(val);
        },
    'format':
        function (val) {
          this.valChange(val);
        },
    'options':
        function (val) {
          this.optChange(val);
        },
  },

  data: () => ({
    /** Function */
    format: null,
    formattedValue: ""
  })
}
</script>

<style scoped>

</style>